/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('webinarModal', ['$window', 'TagManager', 'Usage',
    function ($window, TagManager, Usage) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope) {
                var media_path = '/trends_' + scope.item.media_path;
                var flashvars = {
                    loop: false,
                    menu: false,
                    quality: 'best',
                    autoPlay: true
                };
                var params = {
                    play: true
                };
                var attributes = {
                    styleclass: 'flash-embed'
                };
                scope.$$postDigest( function () {
                    $window.swfobject.embedSWF(media_path, 'webinar_embed', '100%', '100%', 
                        '9.0.0', null, flashvars, params, attributes);

                    document.scope = scope;
                    
                    Usage.log('viewdoc', { item_id: scope.item.pk });
                });

                // Log webinar modal launch on Google Analytics
                TagManager.event('play', {
                    category: 'webinar',
                    label: scope.item.title,
                    value: scope.item.pk
                });
            }
        };
    }]);

// TODO: instead of this, this should be implemented as a feature of the
// carousel, a tracker per say. That keeps track of a given value adds it to
// the given url and loads it to the correct place if in the url,
// but alas not enough time :(
ngModule.directive('webinarUrlLoader', ['$window', 'QuerySerializer', '$timeout',
    function ($window, QuerySerializer, $timeout) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope) {
                var serializer = new QuerySerializer({
                   w: {type: 'number'}, // webinar id
                });

                var state = serializer.load();
                if (state) {
                    // XXX: timeout to make sure this works with slow connections, fix when the above is done. 
                    // really we should be storing the content list promise from loadMore in 
                    // the scope and be calling .then on that
                    $timeout(function() {
                        var id = state.w;
                        var items = scope.content.items;
                        if (id === scope.item.pk) {
                            for (var i=0 ; i < items.length ; i++) {
                                if (items[i].pk === id)  {
                                    var val = i;
                                    var callback = function() {
                                        scope.setPosition(val);
                                    };
                                    $timeout(callback);
                                }
                            }
                        }
                    }, 1000);
                }

                /* Return the shareable URL for a webinar */
                scope.getWebinarUrl = function (id, pk, url_component) {
                    return location.protocol + '//' + location.host + '/trends/#/' + url_component +
                        '/' + id + '?w=' + pk + '&to=webinar';
                };
            }
        };
    }
]);
